import { createStore } from "vuex"
import modules from "./modules/index.js";

const store = createStore({
    state: {},
    modules,
});

export default store;